export default ['type', 'serviceType'];
